const API_URL = process.env.REACT_APP_API_URL;

// Helper function to handle the response from fetch calls
async function handleResponse(response) {
    if (!response.ok) {
        const errorData = await response.json();
        return { error: true, message: errorData.message || 'Network error' };
    }
    return { error: false, data: await response.json() };
}

// Generic fetch function
async function fetchData(url, options = {}) {
    try {
        const response = await fetch(url, options);
        return await handleResponse(response);
    } catch (error) {
        console.error('Fetch error:', error);
        return { error: true, message: error.message };
    }
}

// Create an empty space with additional parameters
export async function createEmptySpace(name, token) {
    if (!name) {
        console.error('Invalid data for creating empty space');
        return { error: true, message: 'name and userID are required' };
    }
    const url = new URL(`${API_URL}/spaces/addEmpty`);
    url.searchParams.append('name', name);

    const options = {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`
        }
    };

    return fetchData(url.toString(), options);
}

// Update an existing space
export async function updateSpace(spaceId, space, token) {
    if (!spaceId || !space) {
        console.error('Invalid input for updating space');
        return { error: true, message: 'Both spaceId and space data are required' };
    }
    const options = {
        method: "PUT",
        headers: {
            "Content-Type": "application/json",
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(space),
    };
    return fetchData(`${API_URL}/spaces/${encodeURIComponent(spaceId)}`, options);
}

// Delete a space
export async function deleteSpace(spaceId, token) {
    if (!spaceId) {
        console.error('No spaceId provided for deletion');
        return { error: true, message: 'spaceId is required for deletion' };
    }
    const options = {
        method: "DELETE",
        headers: {
            'Authorization': `Bearer ${token}`
        },
    };
    return fetchData(`${API_URL}/spaces/${encodeURIComponent(spaceId)}`, options);
}

// Fetch hubs associated with a space
export async function fetchHubsForSpace(spaceId, token) {
    if (!spaceId) {
        console.error('No spaceId provided');
        return { error: true, message: 'spaceId is required' };
    } 
    const options = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
    return fetchData(`${API_URL}/spaces/${encodeURIComponent(spaceId)}/hubs`, options);
}
